import {Directive, Input, OnInit} from '@angular/core';
import {FormlyFieldConfig, FormlyForm} from '@ngx-formly/core';
import {traverse} from '../formly-utils';
// TODO - is it possible to inject the template engine?
//@ts-ignore
import * as Handlebars from 'handlebars/dist/cjs/handlebars';

const injectData = (fields: FormlyFieldConfig[], data: any): FormlyFieldConfig[] => {
  const compareFn = (key: string, value: any): boolean => key === 'html' || key === 'label';
  const processFn = (value: any): any => {
    const template = Handlebars.compile(value);
    return template(data);
  };
  return traverse(fields, compareFn, processFn);
};

@Directive({
  selector: '[zlInjectData]',
  standalone: true
})
export class InjectDataDirective implements OnInit {

  @Input() zlInjectData: any;

  constructor(private formly: FormlyForm) {
  }

  ngOnInit(): void {
    if (!!this.zlInjectData) {
      injectData(this.formly.fields, this.zlInjectData)
    }
  }

}
